export const userConstants = {
  USER_PROFILE: "USER_PROFILE",
  USER_FEEDBACK: "USER_FEEDBACK",
};

export const profileSections = {
  personalDetails: "personalDetails",
  companyDetails: "companyDetails",
  preferences: "preferences",
  passwords: "passwords",
  userFeedback: "userFeedback",
  agentFiles: "agentFiles",
};
